import React from 'react';
import { motion } from 'framer-motion';
import { MousePointerClick, Printer, Paintbrush, Sparkles } from 'lucide-react';
const steps = [{
  n: '1',
  icon: MousePointerClick,
  title: 'Eliges una plantilla',
  desc: 'Más de 300 diseños listos: flores, aves, mandalas, animales y motivos deco.'
}, {
  n: '2',
  icon: Printer,
  title: 'La imprimes',
  desc: 'Se coloca debajo del vidrio, acetato o frasco y funciona como guía.'
}, {
  n: '3',
  icon: Paintbrush,
  title: 'Delineas y pintas',
  desc: 'Sigues el contorno del diseño y rellenas con color translúcido.'
}, {
  n: '4',
  icon: Sparkles,
  title: 'Obtienes tu pieza',
  desc: 'Lista para decorar tu casa, regalar o vender como producto terminado.'
}];
export function TemplatesSection() {
  return <section className="bg-deco-forest py-14 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-192" data-mp="1zmlc4w293vqt">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-[0.95fr_1.05fr] gap-10 lg:gap-16 items-center" data-id="element-193" data-mp="1up1ynyddnmzx">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-194" data-mp="pdw0atrafi1m">
          <div className="rounded-[1.75rem] overflow-hidden border-4 border-deco-cream/10 shadow-2xl" data-id="element-195" data-mp="1347uqzbchsvx">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/3dcff2ac-9fcc-4c6d-911d-c15508161010.jpg" alt="Impresora imprimiendo plantillas de falso vitral" className="w-full object-cover" data-id="element-196" data-mp="6ei4e69zzx8h" />
          </div>
          <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-deco-brick text-white text-[11px] sm:text-xs font-semibold uppercase tracking-[0.15em] px-5 py-2.5 rounded-full shadow-lg whitespace-nowrap" data-id="element-197" data-mp="fh9f23v1uoz2">
            Descargas · Imprimes · Creas
          </div>
        </motion.div>

        <div data-id="element-198" data-mp="1vuzl3g5qbnbc">
          <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-aqua mb-4" data-id="element-199" data-mp="16510v8wjfws7">
            Diseños listos para usar
          </p>
          <h2 className="font-serif text-2xl sm:text-4xl text-deco-cream font-semibold leading-snug mb-4" data-id="element-200" data-mp="115obohi72dmg">
            No necesitas diseñar{' '}
            <span className="italic text-deco-aqua" data-id="element-201" data-mp="1b4dmjqboaxt7">desde cero</span>
          </h2>
          <p className="text-sm text-deco-cream/60 leading-relaxed mb-9 max-w-md" data-id="element-202" data-mp="nej8j5fmb37d">
            La clave del falso vitral es trabajar con plantillas. Imprimes el
            diseño, lo colocas debajo del vidrio y solo sigues el contorno.
          </p>

          <ol className="relative flex flex-col gap-6" data-id="element-203" data-mp="x54ejdxmfa0b">
            <span className="absolute left-[19px] top-3 bottom-3 w-px bg-deco-cream/15" aria-hidden="true" data-id="element-204" data-mp="sdw6al811uoq" />
            {steps.map((step, i) => <motion.li key={step.n} initial={{
            opacity: 0,
            x: -14
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.07,
            ease: [0.23, 1, 0.32, 1]
          }} className="relative flex items-start gap-5" data-id="element-205" data-mp="3vucptmhrwiph" data-mpi={i}>
                <span className="w-10 h-10 rounded-full bg-deco-aqua text-deco-forest flex items-center justify-center shrink-0 z-10" data-id="element-206" data-mp="26dzc1hpkvzjx">
                  <step.icon size={17} strokeWidth={2} data-id="element-207" data-mp="2u0z2413evr7l" />
                </span>
                <div className="pt-0.5" data-id="element-208" data-mp="2z13izs88enyc">
                  <h3 className="font-serif text-base sm:text-lg text-deco-cream font-semibold mb-1 leading-snug" data-id="element-209" data-mp="2l2dkq99oei8e">
                    <span className="text-deco-aqua/70 mr-1.5" data-id="element-210" data-mp="2p2xjtidt7vx6">{step.n}.</span>
                    {step.title}
                  </h3>
                  <p className="text-[13px] text-deco-cream/55 leading-relaxed" data-id="element-211" data-mp="19ldm6vwqj75x">
                    {step.desc}
                  </p>
                </div>
              </motion.li>)}
          </ol>
        </div>
      </div>
    </section>;
}